const currentLanguage = window.document.querySelector('html').getAttribute('lang');
const currencyFormatter = new Intl.NumberFormat(currentLanguage, { minimumFractionDigits: 0 });
const formatCurrency = value => (currencyFormatter.format(value));

export default formatCurrency;
